<template>
  <nav class="nav">
    <ul class="list-items">
      <li v-for="(item, index) in menuList" :key="index" :class="(routeName.toLowerCase() == item.title.eng.toLowerCase()) || (routeName.toLowerCase() == item.title.default.toLowerCase())
        ? 'active'
        : ''" @click="MenuSelect(index)" class="menu-list-item" v-if="(!item.userTypes ||
          (item.userTypes && item.userTypes.includes('ALL')) ||
          (item.userTypes && item.userTypes.includes(getUserType())))">
        <p style="display: flex; gap: 0.4rem; width: fit-content;" class="cursor-pointer slow-underline"
          v-if="!item.isRequiredLogin || (item.isRequiredLogin && subscriberid)">
          <img :src="item.menuIcon" :alt="item.title.default" style="height: 20px; width: 20px;" class="menuIcons" />
          <span class="itemTitle">{{ menuTitleShow(item.title, localDisplayLangCode) }}</span>
        </p>
      </li>
      <li class="more_option" ref="moreDropdown" v-if="moreItemList.length > 0">
        <div @click="showDropdown()" class="more-dropdown">
          <span class="test"></span>
          <div class="hamburger">
            <div></div>
            <div></div>
            <div></div>
          </div>
          <span>{{ $t('more') }}</span>
        </div>
        <ul class="more-dropdown-content" v-show="showMoreContent">
          <li v-for="(item, index) in moreItemList" :key="index" :class="(routeName.toLowerCase() == item.title.eng.toLowerCase()) || (routeName.toLowerCase() == item.title.default.toLowerCase())
            ? 'active'
            : ''" @click="MenuSelect(index, true)" class="menu-list-item more-menu-list-item" v-if="(!item.userTypes ||
              (item.userTypes && item.userTypes.includes('ALL')) ||
              (item.userTypes && item.userTypes.includes(getUserType())))">
            <p style="display: flex; gap: 0.4rem; width: fit-content;" class="cursor-pointer slow-underline"
              v-if="!item.isRequiredLogin || (item.isRequiredLogin && subscriberid)">
              <img :src="item.menuIcon" :alt="item.title.default" style="height: 20px; width: 20px;"
                class="menuIcons" />
              <span class="itemTitle">{{ menuTitleShow(item.title, localDisplayLangCode) }}</span>
            </p>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</template>
<script>
import { eventBus } from "@/eventBus";
import { mapGetters } from "vuex";
import Utility from "@/mixins/Utility.js";

export default {
  name: "NavBar",
  watch: {
    $route(to, from) {
    },
    subscriptionList(val) {
      if (val) {
        this.subscriptions = val;
      }
    },
    localDisplayLangCode(newLang, oldLang) {
      this.getMenuList();
    },
    '$i18n.locale'(newLocale) {
      if (this.localDisplayLangCode !== newLocale) {
        this.localDisplayLangCode = newLocale;
      }
    },
  },
  data() {
    return {
      menuList: [],
      moreItemList: [],
      subscriberProfileDetails: null,
      localDisplayLangCode: null,
      subscriptions: [],
      showMoreContent: false
    };
  },
  created() {
    this.localDisplayLangCode = localStorage.getItem("setDisplayLanguageCode") || this.$i18n.locale || "en";
    this.getMenuList();
    eventBus.$on("check-local-storage", (data) => {
      this.localDisplayLangCode = data || this.$i18n.locale || "en";
      this.getMenuList();
    });
    eventBus.$on("changeLanguageView", () => {
      this.localDisplayLangCode = localStorage.getItem("setDisplayLanguageCode") || this.$i18n.locale || "en";
      this.getMenuList();
    });
    eventBus.$on("configLoaded", this.getMenuList());
  },
  mounted() {
    this.localDisplayLangCode = localStorage.getItem("setDisplayLanguageCode") || this.$i18n.locale || "en";
    document.addEventListener("click", this.handleClickOutside);
  },
  methods: {
    getMenuList() {
      let menuItemsList = [];
      if (this.appConfig.featureEnabled && this.appConfig.featureEnabled.isDeckingEnabled) {
        let dataset = localStorage.getItem("appDeckingConfig") ? JSON.parse(localStorage.getItem("appDeckingConfig")) : '';
        menuItemsList = dataset.screens;
      } else {
        menuItemsList = this.appConfig.screens;
      }
      let currentProfileDetails = localStorage.getItem("subscriberProfileDetails");

      if (currentProfileDetails) {
        currentProfileDetails = JSON.parse(currentProfileDetails);
        this.subscriberProfileDetails = currentProfileDetails;
      }

      const menuListArr = [];
      this.moreItemList = [];

      const isKidsMode = this.subscriberProfileDetails?.kidsmode === "YES";
      const isLoggedIn = !!this.subscriberid;

      menuItemsList?.forEach((menu) => {
        const profileTypes = menu?.profileTypes || [];
        const screenPosition = menu?.screenPosition?.toUpperCase();

        const isTopMenu = screenPosition === "TOP";
        const isMoreMenu = screenPosition === "MORE";
        const status = menu.status === "ACTIVE";

        // Skip if user not logged in
        if (isKidsMode) {
          // Only allow KIDS or ALL in TOP position for kids mode
          if (isTopMenu && status && (profileTypes.includes("KIDS") || profileTypes.includes("ALL"))) {
            menuListArr.push(menu);
          } else if (isMoreMenu && status  && (profileTypes.includes("KIDS") || profileTypes.includes("ALL"))) {
            this.moreItemList.push(menu);
          }
        } else {
          // Allow ADULT, MASTER, or ALL in both TOP and MORE for non-kids mode
          if (isTopMenu && status  && (profileTypes.includes("ADULT") || profileTypes.includes("MASTER") || profileTypes.includes("ALL"))) {
            menuListArr.push(menu);
          } else if (isMoreMenu && status  && (profileTypes.includes("ADULT") || profileTypes.includes("MASTER") || profileTypes.includes("ALL"))) {
            this.moreItemList.push(menu);
          }
        }
      });

      this.menuList = menuListArr;

      // console.log(this.menuList, this.moreItemList, "___moreItemList__")
    },

    menuTitleShow(title, language) {
      if (language === "eng" || language === "en") {
        return title.eng || title.default.toLowerCase();
      } else if (language === "es" || language === "spa") {
        return title.spa || title.es || title.default.toLowerCase();
      } else if (language === "fr") {
        return title.fre || title.default.toLowerCase();
      } else if (language === "mal") {
        return title.mal || title.default.toLowerCase();
      }
      return title.default.toLowerCase();
    },

    MenuSelect(index, isMoreMenue) {
      if (this.showMoreContent) {
        this.showMoreContent = !this.showMoreContent;
      }
      const currentLanguage = this.getCurrentLanguageUrlBase();
      const moreMenuDetail = isMoreMenue ? this.moreItemList[index] : this.menuList[index];
      const sectionTitle = moreMenuDetail.title.eng.replaceAll(' ', '').toLowerCase();

      const basePath = sectionTitle === 'home' ? '/' : `/${sectionTitle}`;
      const path = currentLanguage === 'es' ? basePath : `/en${basePath === '/' ? '' : basePath}`;
      if (sectionTitle == 'home') {
        this.$router.push({
          path,
          name: "Home",
          params: { section: 'home', lang: currentLanguage },
        });
      } else if (sectionTitle == 'epg' || sectionTitle == 'tv') {
        this.$router.push({
          path,
          name: "Epg",
          params: { moreMenuDetail, lang: currentLanguage },
        });
      } else {
        this.$router.push({
          path,
          name: "section-screen",
          params: { section: sectionTitle, lang: currentLanguage },
        });
      }
    },

    getUserType() {
      if (!this.subscriberid) {
        return "GUEST";
      } else if (this.subscriberid && this.subscriptions.length > 0) {
        return "SUBSCRIBED";
      } else {
        return "REGISTERED";
      }
    },

    showDropdown() {
      this.showMoreContent = !this.showMoreContent;
    },
    handleClickOutside(event) {
      if (this.showMoreContent && this.$refs.moreDropdown && !this.$refs.moreDropdown.contains(event.target)) {
        this.showMoreContent = false;
      }
    },

    debugLanguage() {
    }
  },
  computed: {
    ...mapGetters([
      "appConfig",
      "subscriberid",
      "getRtl",
      "subscriptionList",
      "isMovieEnabled",
      "profileid",
      "getPlanDeeplinkPath",
    ]),

    routeName() {
      let tempVar = this.$route.path;
      tempVar = tempVar.toLowerCase();
      if (tempVar.includes("movie")) {
        return "movies";
      } else if (tempVar.includes("channel")) {
        return "channels";
      } else if (tempVar.includes("livetv")) {
        return "Live Tv";
      } else if (tempVar.includes("tvshow")) {
        return "TV Show";
      } else if (tempVar.includes("catchup") || tempVar.includes("/catchup")) {
        return "catchup";
      } else if (tempVar.includes("/series")) {
        return "series";
      } else if (tempVar.includes("shows")) {
        return "shows";
      } else if (tempVar.includes("songs") || tempVar.includes("music") || tempVar.includes('-video-songs')) {
        return "music";
      } else if (tempVar.includes("kids")) {
        return "kids";
      } else if (tempVar.includes("webseries")) {
        return "webseries";
      } else if (tempVar.includes("shorts")) {
        return "shorts";
      } else if (tempVar.includes("watchlist")) {
        return "watchlist";
      } else if (tempVar.includes("devotional")) {
        return "devotional";
      } else if (tempVar.includes("viewAllPlans")) {
        return "plan";
      } else if (tempVar.includes("search")) {
        return "search";
      } else if (tempVar.includes("epg")) {
        return "epg";
      } else if (tempVar.includes("replaytv")) {
        return "replay tv";
      } else if (tempVar.includes("tv")) {
        return "tv";
      } else if (tempVar.includes("sports")) {
        return "sports";
      } else if (tempVar.includes("adultos")) {
        return "adultos";
      } else {
        return "home";
      }
    },
  },
  components: {
    MenuIcons: () => import(/* webpackChunkName: "menuicon" */ "@/components/SvgImages/MenuIconsList.vue"),
  },
  mixins: [Utility],
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
    eventBus.$off("check-local-storage");
    eventBus.$off("changeLanguageView");
  }
}
</script>
<style scoped lang="scss">
@import "@/sass/_variables.scss";
@import "@/sass/_utilities.scss";
@import "./Navbar.scss";

.more_option {
  display: flex;
  align-items: center;
  position: relative;

  .more-dropdown {
    display: flex;
    align-items: center;
  }

  .more-dropdown-content {
    text-align: left;
    position: absolute;
    top: calc(100% + 2px);
    padding: 4px 0;
    min-height: 30px;
    max-height: 300px;
    background: #323232;
    width: 250px;
    left: 0;
    z-index: 2;
    box-shadow: 7px 7px 5px 0 rgba(24, 24, 24, .8);
    transition: .2s ease-in-out;
    overflow: hidden;

    .menu-list-item {
      padding: 1rem;
    }
  }
}

@media screen and (max-width: 1023px) {
  .test:after {
    display: none;
  }

  .hamburger {
    width: 20px;
    height: 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .hamburger div {
    height: 2.75px;
    background-color: #ffffff;
    border-radius: 1px;
  }

  .more-dropdown {
    flex-direction: column;
    gap: 0.4rem;
  }
}

@media screen and (min-width: 1024px) {
  .test:after {
    content: '\2807';
    font-size: 25px;
  }

  .hamburger {
    display: none;
  }
}
</style>